import React, { useContext, useMemo, useState, useEffect } from 'react';
import { useFetch } from '../../../../../core/hooks/UseFetch';
import EntitlementApi from '../../../../../core/apis/EntitlementApi';
import ImportPermissionsContext from '../ImportPermissionsContext';
import UserAuthorizationUpdate from '../../UserAuthorizationUpdate';
import { Loading } from 'ra-ui-materialui';
import { Grid, makeStyles } from '@material-ui/core';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import { useProfile } from '../../../../../core/hooks/UseProfile';
import pullAll from 'lodash/pullAll';
import Typography from '@material-ui/core/Typography';
import useNotifyServerError from '../../../../../core/hooks/useNotifyServerError';
import { USERTYPE } from '../../../EnumUserType';
import { createUserAuthorizations } from '../../stepper/utils';

const PermissionGroupsStep = () => {
  const notifyServerError = useNotifyServerError();
  const [groupsFilter, setGroupsFilter] = useState('ONLY_ASSIGNED');
  const [idsUserChosen, setIdsUserChosen] = useState([]);
  const [
    authorizationsConnectedUser,
    setAuthorizationsConnectedUser
  ] = useState([]);
  const { profile: loggedInUser } = useProfile();
  const classes = useStyles();
  const {
    userToCopy,
    groups,
    funds,
    onChangeAuthorizationsForImport,
    setAuthorizationsUserChosen,
    userId,
    hasWriteAuthorizationPermission
  } = useContext(ImportPermissionsContext);

  useEffect(() => {
    const { userType, userId: id } = loggedInUser;
    userType !== USERTYPE.superAdmin &&
      EntitlementApi.getAuthorizationsByUserId(id)
        .then(authorizations => {
          setAuthorizationsConnectedUser(authorizations);
        })
        .catch(notifyServerError);
  }, [loggedInUser, notifyServerError]);

  const { data = [], loading } = useFetch(
    EntitlementApi.getAuthorizationsByUserId,
    userToCopy.userId
  );

  const [formCtrlLabel1Cls, formCtrlLabel2Cls] = useMemo(
    () => [
      { root: classes.topToolbar },
      { label: classes.radioLabel },
      { root: classes.radioLabelRoot, label: classes.radioLabel }
    ],
    [classes]
  );

  const onChangeAuthorizations = (
    _newAuthorizationsToUpdateBoolean,
    newAuthorizationsToUpdateArray
  ) => {
    const final = newAuthorizationsToUpdateArray.map(
      authorization =>
        `${authorization.userId}:${authorization.investorId}:${authorization.fundId}:${authorization.groupId}`
    );

    pullAll(idsUserChosen, final);
    onChangeAuthorizationsForImport(newAuthorizationsToUpdateArray);
  };

  //create userautorizations from the user we choose on the step 1
  const authorizationsUserChosen = useMemo(() => {
    setAuthorizationsUserChosen(createUserAuthorizations(data));
    return createUserAuthorizations(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  //create ids array to filters the authorizations the user chosen have access to
  useEffect(() => {
    setIdsUserChosen(
      (data || []).map(
        authorization =>
          `${userId}:${authorization.investorId}:${authorization.fundId}:${authorization.groupId}`
      )
    );
  }, [data, userId]);

  if (loading) return <Loading className={classes.loading} />;
  return (
    <div className={classes.container}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Typography
            variant="h5"
            style={{ paddingTop: '0px', paddingBottom: '10px' }}
          >
            Select Permission Groups
          </Typography>
          <span className={classes.paragraph}>
            Below are assigned permissions of the selected contact. Select which
            ones you want to import.
          </span>
        </Grid>
      </Grid>
      <Grid container justifyContent="space-between" alignItems="center">
        <span className={classes.contactInformation}>
          Contact:{' '}
          <span className={classes.bold} style={{ marginRight: '10px' }}>
            {userToCopy.firstName} {userToCopy.lastName}
          </span>{' '}
          User ID: <span className={classes.bold}>{userToCopy.userId}</span>
        </span>
        <RadioGroup
          aria-label="groupsFilter"
          name="groupsFilter"
          value={groupsFilter}
          onChange={e => setGroupsFilter(e.target.value)}
          row
          style={{ margin: 0 }}
        >
          <FormControlLabel
            value="ALL"
            control={<Radio color="primary" id="show-all" />}
            label="Show All"
            classes={formCtrlLabel1Cls}
            id="show-all"
          />
          <FormControlLabel
            value="ONLY_ASSIGNED"
            control={<Radio color="primary" id="show-assigned" />}
            label="Show Assigned"
            classes={formCtrlLabel2Cls}
            style={{ marginRight: 0 }}
          />
        </RadioGroup>
      </Grid>
      <UserAuthorizationUpdate
        hasWriteAuthorizationPermission={hasWriteAuthorizationPermission}
        groups={groups}
        groupsFilter={groupsFilter}
        ids={idsUserChosen}
        funds={funds}
        userType={userToCopy.userType}
        userProfile={loggedInUser}
        authorizations={authorizationsUserChosen}
        authorizationsConnectedUser={createUserAuthorizations(
          authorizationsConnectedUser
        )}
        newAuthorizations={[]}
        wizardMode
        id={userId}
        onChangeAuthorizations={onChangeAuthorizations}
      />
    </div>
  );
};
const useStyles = makeStyles({
  container: {
    flexDirection: 'column',
    width: '100%',
    justifyContent: 'flex-start'
  },
  loading: {
    width: '100%',
    height: 'calc(100vh - 230px)'
  },
  topToolbar: {
    paddingTop: 0,
    paddingBottom: 0
  },
  radioLabel: {
    fontSize: '14px'
  },
  radioLabelRoot: {
    marginRight: '0px !important'
  },
  paragraph: {
    fontSize: '14px'
  },
  contactInformation: {
    fontSize: '14px',
    paddingTop: '15px'
  },
  bold: {
    fontWeight: '600'
  }
});

export default PermissionGroupsStep;
